(() => {
  if (window.__ALSO_LIKE_FULL_SCRIPT__) return;
  window.__ALSO_LIKE_FULL_SCRIPT__ = true;

  const SELECTOR_ROOT = "[data-cart-also-like]";
  const SELECTOR_SWIPER = "[data-cart-also-like-swiper]";
  const DRAWER_CONTAINER_SELECTOR = "#CartDrawer";
  const SECTION_IDS = ["cart-drawer", "cart-icon-bubble"];

  const instances = new WeakMap();
  const inflight = new Set();

  function isMeasurable(el) {
    return !!el && el.offsetWidth > 0 && el.offsetHeight > 0;
  }

  function rafDelay() {
    return new Promise((r) => requestAnimationFrame(() => r()));
  }

  async function waitUntilMeasurable(el, tries = 40) {
    for (let i = 0; i < tries; i++) {
      if (isMeasurable(el)) return true;
      await rafDelay();
    }
    return isMeasurable(el);
  }

  // ---------------- Swiper init/destroy ----------------

  function hideCurrentProduct(root) {
    const currentPath = window.location.pathname;
    root.querySelectorAll('.cart-also-like__slide[data-product-url]').forEach(function (slide) {
      if (slide.getAttribute('data-product-url') === currentPath) {
        slide.style.display = 'none';
      } else {
        slide.style.display = '';
      }
    });
  }

  async function initOne(root) {
    if (!root || instances.has(root)) return;

    hideCurrentProduct(root);

    const swiperEl = root.querySelector(SELECTOR_SWIPER);
    if (!swiperEl) return;
    if (typeof window.Swiper !== "function") return;

    const ok = await waitUntilMeasurable(swiperEl, 40);
    if (!ok) return;

    const nextEl = root.querySelector("[data-next]");
    const prevEl = root.querySelector("[data-prev]");
    const paginationEl = root.querySelector("[data-pagination]");

    const progressEl = root.querySelector("[data-also-like-progress]");
    const fillEl = root.querySelector("[data-also-like-progress-fill]");

    const params = {
      slidesPerView: "auto",
      spaceBetween: 32,
      freeMode: true,
      watchOverflow: true,
      breakpoints: {
        600: {
          slidesPerView: 1.1,
          freeMode: false,
        },
      },
    };

    if (nextEl && prevEl) params.navigation = { nextEl, prevEl };
    if (paginationEl) params.pagination = { el: paginationEl, clickable: true };

    let sw;
    try {
      sw = new window.Swiper(swiperEl, params);
    } catch (err) {
      try {
        sw = new window.Swiper(swiperEl, {
          slidesPerView: params.slidesPerView,
          spaceBetween: params.spaceBetween,
          watchOverflow: params.watchOverflow,
          breakpoints: params.breakpoints,
        });
      } catch (err2) {
        console.error("ALSO LIKE swiper init failed:", err2);
        return;
      }
    }

    function renderProgress() {
      if (!progressEl || !fillEl || !sw || sw.destroyed) return;

      const snaps = Array.isArray(sw.snapGrid) ? sw.snapGrid : [];
      const pages = Math.max(1, snaps.length);

      if (sw.isLocked || pages <= 1) {
        progressEl.classList.add("is-hidden");
        progressEl.classList.remove("is-active");
        fillEl.style.width = "0%";
        return;
      }

      progressEl.classList.remove("is-hidden");

      const current = Math.min(pages, Math.max(1, (sw.snapIndex ?? 0) + 1));
      const pct = Math.round((current / pages) * 100);
      fillEl.style.width = `${pct}%`;

      if (sw.isEnd) {
        progressEl.classList.remove("is-active");
      } else {
        progressEl.classList.add("is-active");
      }
    }

    sw.__alsoLikeRenderProgress = renderProgress;

    try {
      sw.on("init", renderProgress);
      sw.on("update", renderProgress);
      sw.on("resize", renderProgress);
      sw.on("snapIndexChange", renderProgress);
      sw.on("slideChange", renderProgress);
      sw.on("transitionEnd", renderProgress);
    } catch (_) {}

    requestAnimationFrame(() => {
      try {
        sw.update();
      } catch (_) {}
      renderProgress();
    });

    instances.set(root, sw);
  }

  function destroyOne(root) {
    const sw = instances.get(root);
    if (sw) {
      const fn = sw.__alsoLikeRenderProgress;

      if (fn && typeof sw.off === "function") {
        try {
          sw.off("init", fn);
        } catch (_) {}
        try {
          sw.off("update", fn);
        } catch (_) {}
        try {
          sw.off("resize", fn);
        } catch (_) {}
        try {
          sw.off("snapIndexChange", fn);
        } catch (_) {}
        try {
          sw.off("slideChange", fn);
        } catch (_) {}
        try {
          sw.off("transitionEnd", fn);
        } catch (_) {}
      }

      if (typeof sw.destroy === "function") {
        try {
          sw.destroy(true, true);
        } catch (_) {}
      }
    }
    instances.delete(root);
  }

  function initAll(container = document) {
    container.querySelectorAll(SELECTOR_ROOT).forEach((r) => initOne(r));
  }

  function destroyAll(container = document) {
    container.querySelectorAll(SELECTOR_ROOT).forEach(destroyOne);
  }

  // ---------------- Sections re-render (SAFE for Dawn drawer) ----------------

  async function fetchSections() {
    const root =
      window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : "/";
    const url = `${root}?sections=${SECTION_IDS.join(",")}&t=${Date.now()}`;

    const res = await fetch(url, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store",
    });

    if (!res.ok) throw new Error("Sections fetch failed");
    return res.json();
  }

  function replaceInnerFromHTML(sectionHtml, selector, targetSelector) {
    const target = document.querySelector(targetSelector);
    if (!target || !sectionHtml) return false;

    const doc = new DOMParser().parseFromString(sectionHtml, "text/html");
    const fresh = doc.querySelector(selector);
    if (!fresh) return false;

    target.innerHTML = fresh.innerHTML;
    return true;
  }

  function rerenderFromSections(sections) {
    if (sections["cart-drawer"]) {
      replaceInnerFromHTML(
        sections["cart-drawer"],
        "#CartDrawer-CartItems",
        "#CartDrawer-CartItems",
      );
      replaceInnerFromHTML(
        sections["cart-drawer"],
        ".drawer__footer-wrapper",
        ".drawer__footer-wrapper",
      );
    }

    if (sections["cart-icon-bubble"]) {
      const bubble = document.querySelector("cart-icon-bubble");
      if (bubble) {
        const doc = new DOMParser().parseFromString(
          sections["cart-icon-bubble"],
          "text/html",
        );
        const fresh = doc.querySelector("cart-icon-bubble");
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      }
    }
  }

  function reviveThemeCart() {
    try {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (_) {}
    try {
      document.dispatchEvent(new CustomEvent("cart:updated"));
    } catch (_) {}
    try {
      document.dispatchEvent(new CustomEvent("cart:rendered"));
    } catch (_) {}

    const drawerEl = document.querySelector("cart-drawer");
    try {
      drawerEl?.renderContents?.();
    } catch (_) {}
    try {
      drawerEl?.trapFocus?.();
    } catch (_) {}
  }

  async function rerenderCartUI() {
    destroyAll(document);

    const sections = await fetchSections();
    rerenderFromSections(sections);

    reviveThemeCart();
    initAll(document);
  }

  // ---------------- Qty getter ----------------

  function getQtyFromButton(btn) {
    const scope =
      btn.closest(".swiper-slide") ||
      btn.closest(".cart-item") ||
      btn.closest(SELECTOR_ROOT) ||
      document;

    const input = scope.querySelector?.(".quantity__input");
    let qty = parseInt(input?.value || "1", 10);
    if (!Number.isFinite(qty) || qty < 1) qty = 1;
    return qty;
  }

  // ---------------- Custom qty +/- for also-like ----------------

  function handleAlsoLikeQtyClick(btn) {
    const qi = btn.closest("quantity-input");
    if (!qi) return false;
    if (!qi.hasAttribute("data-also-like-qty")) return false;

    const input = qi.querySelector(".quantity__input");
    if (!input) return true;

    const min = parseInt(input.getAttribute("min") || "1", 10);
    const step = parseInt(input.getAttribute("step") || "1", 10);
    const cur = parseInt(input.value || String(min), 10);

    const next =
      btn.getAttribute("name") === "minus"
        ? Math.max(min, (Number.isFinite(cur) ? cur : min) - step)
        : (Number.isFinite(cur) ? cur : min) + step;

    input.value = String(next);
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
    return true;
  }

  document.addEventListener(
    "click",
    (e) => {
      const qBtn = e.target.closest(
        "quantity-input[data-also-like-qty] .quantity__button",
      );
      if (!qBtn) return;

      if (!qBtn.closest("#CartDrawer")) return;

      e.preventDefault();
      e.stopPropagation();
      handleAlsoLikeQtyClick(qBtn);
    },
    true,
  );

  // ---------------- Add to cart ----------------

  async function addToCart(variantId, qty, button) {
    const vid = String(variantId || "");
    if (!vid) return;

    const q = Math.max(1, parseInt(qty || "1", 10));
    const inflightKey = `${vid}:${q}`;

    if (inflight.has(inflightKey)) return;
    inflight.add(inflightKey);

    button?.setAttribute("disabled", "disabled");
    button?.classList?.add("is-loading");

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: q }] }),
      });

      if (!res.ok) throw new Error("Add to cart failed");
      await rerenderCartUI();
    } catch (e) {
      console.error(e);
    } finally {
      inflight.delete(inflightKey);
      button?.classList?.remove("is-loading");
      button?.removeAttribute("disabled");
      if (button?.dataset) delete button.dataset.atcBusy;
    }
  }

  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest("[data-atc]");
      if (!btn) return;

      const inAlsoLike = btn.closest("[data-cart-also-like]");
      const inDrawer = btn.closest("#CartDrawer");
      if (!inAlsoLike || !inDrawer) return;

      if (btn.dataset.atcBusy === "1") {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      btn.dataset.atcBusy = "1";

      const variantId = btn.getAttribute("data-variant-id");
      const qty = getQtyFromButton(btn);

      addToCart(variantId, qty, btn);
    },
    true,
  );

  // ---------------- Observer ----------------

  function observeCartDrawer() {
    const target = document.querySelector(DRAWER_CONTAINER_SELECTOR);
    if (!target) return;

    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type !== "childList") continue;

        m.removedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.matches?.(SELECTOR_ROOT)) destroyOne(n);
          n.querySelectorAll?.(SELECTOR_ROOT).forEach(destroyOne);
        });

        m.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.matches?.(SELECTOR_ROOT)) initOne(n);
          n.querySelectorAll?.(SELECTOR_ROOT).forEach((r) => initOne(r));
        });
      }
    });

    mo.observe(target, { childList: true, subtree: true });
  }

  initAll(document);
  observeCartDrawer();

  document.addEventListener("keyup", () => initAll(document));
})();

(() => {
  if (window.__CART_ACTIONS_MOVE__) return;
  window.__CART_ACTIONS_MOVE__ = true;

  const DRAWER = "#CartDrawer";
  const MOBILE_BP = 530;

  function moveOneCartItem(itemEl, toMobile) {
    const desktopHost = itemEl.querySelector("[data-actions-desktop]");
    const mobileHost = itemEl.querySelector("[data-actions-mobile]");
    if (!desktopHost || !mobileHost) return;
    if (toMobile) {
      if (!mobileHost.contains(desktopHost))
        mobileHost.appendChild(desktopHost);
    } else {
      if (!itemEl.contains(desktopHost)) itemEl.appendChild(desktopHost);
      const content = itemEl.querySelector(".cart-item__content");
      if (content && !content.contains(desktopHost))
        content.appendChild(desktopHost);
    }
  }

  function applyLayout() {
    const drawer = document.querySelector(DRAWER);
    if (!drawer) return;

    const toMobile = window.innerWidth <= MOBILE_BP;

    drawer.querySelectorAll(".cart-item").forEach((itemEl) => {
      moveOneCartItem(itemEl, toMobile);
    });
  }

  // initial
  applyLayout();

  // on resize
  let t;
  window.addEventListener("resize", () => {
    clearTimeout(t);
    t = setTimeout(applyLayout, 120);
  });

  // when drawer rerenders (Shopify sections)
  const drawerEl = document.querySelector(DRAWER);
  if (drawerEl) {
    const mo = new MutationObserver(() => applyLayout());
    mo.observe(drawerEl, { childList: true, subtree: true });
  }

  document.addEventListener("cart:refresh", applyLayout);
  document.addEventListener("cart:updated", applyLayout);
})();
